import {showFeedbackMsg} from '../js/helper/feedbackMsg';

import axios from 'axios';

// 驗證 token 效期用
import {jwtDecode} from "jwt-decode";
const dayjs = require('dayjs');
const _utc = require('dayjs/plugin/utc');
const _timezone = require('dayjs/plugin/timezone'); // dependent on utc plugin
dayjs.extend(_utc);
dayjs.extend(_timezone);

/*
使用範例
let apiData = null;
try {
    apiData = await sendApiRequest('post', '/managers/menu', null)
        .then(res => res.data);

} catch(error){
    globalErrorHandler(error);
    // ...其他錯誤處理程序
}
*/
export async function sendApiRequest(method, url, setting = null, token = null){

    // 若指定 token 參數 (帶入任意字串) 可模擬 token 過期的情況
    const xCsrfToken = token? token : document.querySelector('meta[name="csrf-token"]').content;

    let header = {
        'X-CSRF-TOKEN': xCsrfToken,
        'Content-Type': 'application/json'
    }

    if(token === 'none'){
        delete header['X-CSRF-TOKEN'];
    }

    // const server = '';
    // server 端需要允許 CORS
    // const server = await getSolServer();

    method = method.toLowerCase();

    return axios({
        headers: header,
        method: method,
        // url: `${server}${url}`,
        url: url,
        data: setting
      });
}

// ----- JWT token 請求 ----- //
export async function sendJWTRequest(token, method, url, data = null, signal = false){
    // signal: 可加入 signal 設定，目前用於 abortControl 取消請求

    const header = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    }

    const setting = {
        headers: header,
        method: method.toLowerCase(),
        url: url
    }

    if(data){
        setting['data'] = data;
    }

    if(signal){
        setting['signal'] = signal;
    }

    return axios(setting);
}

// ----- 錯誤處理程序 ----- //
// error 有兩種可能的格式
// 1. API 回應的錯誤訊息 (Object)
// 2. try catch 丟出的錯誤訊息 (String)
export function globalErrorHandler(error){

    // TEST
    // error = 'error message test...';

    // box 實體
    const apiErrBox = window.apiErrBox;

    // UI 文字：錯誤訊息
    const errText = window.langTxt.apiMsg.error;

    // 對話框標題
    let boxTitle = errText['title'];

    // 要顯示的錯誤訊息
    let errMsg = '';

    // 來自 API 回應的錯誤訊息
    if(Object.hasOwn(error, 'response')){
        try {
            const res = error.response;

            const status = res.status;

            if(status){
                boxTitle = errText['titleErrCode'].replace(
                    '{variable}', `<span class="status-code">${status}</span>`
                );
                // error code 自訂說明文字 ex: 'code413
                const name = `code${status}`;
                if(Object.hasOwn(errText, name)){
                    errMsg += `<p>${errText[name]}</p>`;
                }
            }

            if(res.data.message && res.data.message.length > 0){
                errMsg += `<p>${res.data.message}</p>`;
            }
        } catch(error){
            console.log(error);
        }
    } else {
        // 純文字訊息
        errMsg = `<p>${error}</p>`;
    }

    // 請選擇關閉此對話框，或重新載入目前頁面。
    const tips = `<p>${errText['tips']}</p>`;

    const content =
    `<div class="error-msg">
        ${errMsg}
        ${tips}
    </div>`;

    apiErrBox.set_title(boxTitle);
    apiErrBox.set_content(content);
    apiErrBox.open();
}

// ----- 針對 Azure API ----- //
export function sendAzureRequest(method, url, key, setting, type){

    method = method.toLowerCase();

    const headers = {
        'Content-Type': type,
        'Ocp-Apim-Subscription-Key': key // Azure API key
    }

    return axios({
        headers: headers,
        method: method,
        url: url,
        data: setting
      });
}

// ----- 取得 /managers/menu ----- //
export async function getManagersMenu(){

    // 優先使用 window 變數中現存的資料
    if(window.managersMenuData){
        return window.managersMenuData;
    }

    // 未登入
    if(!window.mainUser){
        return null;
    }

    // crossRole: 是否取得跨權限資料 (all_credentials=1)
    let crossRole = true;

    // 根據 high role 決定是否取得跨權限資料
    try {
        const userInfo = window.mainUser.userRoleInfo;
        const highRoleCode = userInfo.highRoleCode;

        if(highRoleCode === 'cem' || highRoleCode === 'dm'){
            crossRole = false;
        }
    } catch(error){
        console.log(error);
    }

    try {
        let url = '/managers/menu';

        if(crossRole){
            url += '?all_credentials=1';
        }

        const apiData = await sendApiRequest('post', url, null)
            .then(res => res.data);

        if(apiData.ajaxcode === 0){
            // 將結果儲存到 window 變數
            window.managersMenuData = apiData;
            return apiData;
        } else {
            throw 'managers-menu error';
        }

    } catch(error){
        // globalErrorHandler(error);
        showFeedbackMsg('managers-menu error', 'fail');
        return null;
    }
}

// ----- 取得 /managers/menu 跨權限的資料 ----- //
// 取得跨權限的所有可見公司站點 (?all_credentials=1)
// 但是必須有公司管理或站點管理權限才列入計算
// 注意：目前只有在 dashboard 使用此種權限控管，為了不影響其他頁面，所以獨立一個 function
// 不能由 window.managersMenuData 中取得資料，也不能回存資料到此變數
/*
export async function getManagersMenuAll(){

    let result = null;

    try {
        // crossRoleTest 暫時只作用在 dev 環境
        // 如果是 com 或 sm，可直接使用 global 變數中的資料，不用重複取得
        // const roleCode = window.mainUser.userRoleInfo.role;
        // if(roleCode === 'com' || roleCode === 'sm'){
        //     if(window.env === 'dev' && window.managersMenuData){
        //         return window.managersMenuData;
        //     }
        // }

        // 以下為正常程序
        const method = 'post';
        const url = '/managers/menu?all_credentials=1';

        const apiData = await sendApiRequest(method, url, null)
            .then(res => res.data);

        if(apiData.ajaxcode === 0){
            result = apiData;
        }

    } catch(error){
        globalErrorHandler(error);
        // ...其他錯誤處理程序
    }

    return result;
}
*/

// ----- 取得公告內容 ----- //
export async function getAnnouncement(){
    return axios.get('/assets/json/announcement.json',{
        // 避免 cache
        params: {
          'timestamp': Date.now()
        },
      });
}


// ----- 取得伺服器列表清單，並返回指定的 Url ----- //
// 正式站 https://sol.careexpert.life/EndPoint
// 測試站 https://soldev.careexpert.life/EndPoint
// services: 'Web' (雲端平台) | 'Mgr' (Justus, Dashboard)
export async function getEndPoint(service){
    // TEST
    // window.serverInfo['app_env'] = 'staging';
    // window.serverInfo['app_env'] = 'production';
    // delete window.serverInfo['app_env'];
    // delete window.serverInfo['justus_api_url'];
    // delete window.env;

    // 如果無法取得 EndPoint 或發生任何錯誤時預設返回空字串
    // 這樣會以當前根目錄為入口
    let result = '';

    try {
        const appEnv = window.serverInfo['app_env'];
        const root = window.serverInfo['justus_api_url'];

        // staging 需要用正式站的 justus api
        // 所以此處要略過 staging，改用接下的程序判斷
        if(root && root.length > 0 && appEnv !== 'staging'){
            // 去掉末尾的 '/api'
            // 因為從 EndPoint 拿到的資料中，url 不包含 '/api'
            // 所以在這邊要維持一致的規則
            result = root.replace(/\/api\b/g, '');
        } else {
            // 無法從 serverInfo 中取值，改用 EndPoint API
            let subdomain = 'sol';

            if(window.env === 'dev' && appEnv !== 'staging'){
                subdomain = 'soldev';
            }

            const params = '?returnAll=true';
            const url = `https://${subdomain}.careexpert.life/EndPoint${params}`;

            // 取得的 endPointlist 資料結構參考
            // resources/layout/src/js/資料範例_EndPoint.js
            const endPointlist = await axios.get(url)
                .then((res) => {
                    return res.data;
                })
                .then((data) => {
                    if(data.status === 'success'){
                        return data.data;
                    } else {
                        throw 'EndPoint error';
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    return null;
                });

            if(!Array.isArray(endPointlist)){
                throw 'EndPoint error';
            }

            // 取得目前網址，格式為 https://hostname
            const loc = window.location;
            let host = `${loc.protocol}//${loc.hostname}`;

            // TEST
            // host = 'https://taiwan.alcolog.io';
            // host = 'https://alcolog.careexpert.life';

            let hostAlias = null;

            // 因為無法確定 endPoint 中的正式站網址是新的還舊的
            // 所以在此處設定別名方便接下來的檢查程序
            switch(host){
                case 'https://taiwan.alcolog.io':
                    hostAlias = 'https://alcolog.careexpert.life';
                    break;

                case 'https://alcolog.careexpert.life':
                    hostAlias = 'https://taiwan.alcolog.io';
                    break;
            }

            let Data = null;

            endPointlist.forEach((data) => {
                // 只需要檢查其中的 services 資料
                data.services.forEach((item) => {
                    if(item['service'] === 'Web'){
                        // 比對 Web 服務的網址是否與 host / hostAlias 相同
                        if(item['url'] === host || item['url'] === hostAlias){
                            Data = data.services;
                        }
                    }
                });

            });

            if(Data){
                // 根據傳入的 service 值，找到對應的 url
                const target = Data.find((item) => {
                    return item['service'] === service;
                });
                result = target['url'];
            }
        }

    } catch(error){
        console.log(error);
    } finally {
        // if(window.env === 'dev' && result.length > 0){
        //     console.log(`Justus Root: ${result}`);
        // }
        return result;
    }

}


// ----- 根據 user email 取的 server domain name ----- //
// 目前不需要此程序，改用 getEndPoint 取得伺服器列表清單
export async function getSolServer(email = null){

    let server = null;

    const localStorageData = localStorage.getItem('solserver');

    // console.log(window.solserver);
    // console.log(localStorageData);

    // 先檢查 window 或 localStorage 有沒有已存資料
    // 優先使用 window.solserver
    if(window.solserver){
        server = window.solserver;
    } else if(localStorageData){
        server = localStorageData;
    }

    if(!server){

        let userEmail = null;

        if(email){
            userEmail = email;
        } else if(window.mainUser){
            const userData = window.mainUser.rawData;
            const mail = userData.user.email;
            if(mail && mail.length > 0){
                userEmail = mail;
            }
        }

        if(userEmail){
            const url =
            `https://soldev.careexpert.life/Find/User/${userEmail}`;

            server = await axios.get(url)
                .then((res) => {
                    return res.data;
                })
                .then((data) => {
                    if(data.status === 'success'){
                        return data.data.Web;
                    } else {
                        return null;
                    }
                });

            if(server){
                window.solserver = server;
                localStorage.setItem('solserver', server);
            }
        }
    }
    // 如果沒有 server 資料的話返回空字串
    return (server)? server : '';
}

// ===== 檢查 JWT token 效期，有需要的話重新取得 token //
// 參考 dashboard checkToken 的做法
export async function checkTokenExpiry(token){

    // token decode
    const jwt = jwtDecode(token);

    // 現在時間
    const now = dayjs();

    // token 過期時間 (JWT 的時間單位是秒)
    const exp = dayjs.unix(jwt.exp);
    // const iat = dayjs.unix(jwt.iat); // 簽發時間

    // 比較 token 過期時間與現在時間 (秒)
    // By default, dayjs#diff will truncate the result to zero decimal places, returning an integer. If you want a floating point number, pass true as the third argument.
    const diff = exp.diff(now, 'second', true);

    // if(window.env === 'dev'){
    //     console.log(`token ${diff} 秒後過期`);
    // }

    let renew = false;

    // 這邊不使用 Justus 的 /Me/refresh 刷新 token，有以下原因
    // 1. Justus 限制較嚴格，必須經過一定時間後才能刷新，例如 token 效期必須需過半 (詳細時間規則需要再確認)，且刷新後也一樣是拿到新的 token，並不是延長效期
    // 2. 實際上這邊用的 token 也不是來自 Justus，而是來自 Laravel 的 /user/info，且效期較短 (30 分鐘)，因此為了來源一致及簡化程序，在 token 快到期前透過 /user/info 直接取得新 token 即可
    if(diff < 60){
        try {
            document.body.classList.add('loading');

            const userInfo = await sendApiRequest('post', '/user/info', null)
                .then(res => res.data);

            token = userInfo['data']['jwt'];
            renew = true;

        } catch(error){
            globalErrorHandler(error);
            // console.log(error);
        } finally {
            document.body.classList.remove('loading');
        }
    }

    return {
        token: token, // JWT token
        renew: renew // token 是否更新過 true | false
    };
}